import React from 'react';
import {
  Modal,
  Group,
  Stack,
  Title,
  Text,
  Avatar,
  Card,
  Button,
  Badge,
  Box,
  CopyButton,
  ActionIcon,
  Tooltip
} from '@mantine/core';
import { IconBrandDiscord, IconCopy, IconCheck } from '@tabler/icons-react';

interface ContactFormProps {
  opened: boolean;
  onClose: () => void;
}

export const ContactForm: React.FC<ContactFormProps> = ({ opened, onClose }) => {
  const DISCORD_USER_ID = '159068309667446784';
  const DISCORD_USERNAME = 'levil.';
  const DISCORD_AVATAR = 'https://imgur.com/6mRNL6n.png';

  return (
    <Modal
      opened={opened}
      onClose={onClose}
      title={
        <Group>
          <IconBrandDiscord size={20} color="#5865f2" />
          <Title order={3}>Contact Me on Discord</Title>
        </Group>
      }
      size="md"
      styles={{
        content: {
          background: 'linear-gradient(145deg, #1a1a1a 0%, #2a2a2a 100%)',
          border: '1px solid rgba(255, 255, 255, 0.1)'
        },
        header: {
          background: 'transparent',
          borderBottom: '1px solid rgba(255, 255, 255, 0.1)'
        }
      }}
    >
      <Stack gap="lg">
        <Card mt={15} p="lg" style={{ background: 'rgba(255, 255, 255, 0.05)' }}>
          <Stack gap="md" align="center">
            <Avatar
              src={DISCORD_AVATAR}
              size={80}
              radius="md"
            />
            <Box ta="center">
              <Title order={4}>{DISCORD_USERNAME}</Title>
              <Text c="dimmed" size="sm">@{DISCORD_USERNAME}</Text>
            </Box>
            
            <Badge 
              leftSection={<IconBrandDiscord size={12} />}
              variant="filled" 
              color="indigo"
              size="lg"
            >
              Discord User
            </Badge>
          </Stack>
        </Card>

        <Stack gap="sm">
          <Text size="sm" c="dimmed" ta="center">
            You can reach me on Discord using my User ID:
          </Text>
          
          <Card p="md" style={{ background: 'rgba(88, 101, 242, 0.1)' }}>
            <Group justify="space-between">
              <Text ff="monospace" fw={500}>{DISCORD_USER_ID}</Text>
              <CopyButton value={DISCORD_USER_ID}>
                {({ copied, copy }) => (
                  <Tooltip label={copied ? 'Copied!' : 'Copy ID'}>
                    <ActionIcon 
                      color={copied ? 'green' : 'gray'} 
                      onClick={copy}
                      variant="subtle"
                    >
                      {copied ? <IconCheck size={16} /> : <IconCopy size={16} />}
                    </ActionIcon>
                  </Tooltip>
                )}
              </CopyButton>
            </Group>
          </Card>
        </Stack>

        <Text size="sm" c="dimmed" ta="center">
          Add me as a friend on Discord or send me a direct message using the ID above.
          You can also find me in various development and tech communities!
        </Text>

        <Button
          fullWidth
          leftSection={<IconBrandDiscord size={16} />}
          variant="gradient"
          gradient={{ from: 'indigo.6', to: 'blue.4' }}
          component="a"
          href="https://discord.com/channels/@me"
          target="_blank"
          rel="noopener noreferrer"
        >
          Open Discord
        </Button>
      </Stack>
    </Modal>
  );
}; 